import {createImageUrlBuilder} from "@sanity/image-url";

const imgUrlBuilder = createImageUrlBuilder({ projectId: process.env.NEXT_PUBLIC_SANITY_PROJECTID as string, dataset: process.env.NEXT_PUBLIC_SANITY_DATASET as string });

export function urlForAsset(assetRef: string): ReturnType<typeof createImageUrlBuilder> {
	return imgUrlBuilder.image(assetRef);
}